// ENG-3451: the studio-side mirror of the append-only
// `UserRegistryGetUserResponse.provider` field (api/v1/user_registry.proto
// tag 12 — "database" | "google", empty when unknown). This module is the
// single place that recognizes the wire values; everything else consumes the
// normalized `UserProvider` type. Deliberately a leaf module (no imports) so
// both the auth mapping (auth/utils.ts) and the depot state type
// (depot/types.ts) can reference it without an import cycle.
// Per rule: code-comments-required + reference-rules-in-comments
// (ai.knowledge/global).

/**
 * Persisted Auth0 identity provider for a Studio account. The wire contract
 * is open-ended (proto3 `string`), so this union is the set Studio has
 * dedicated behavior for; every other value normalizes to `undefined`
 * ("unknown") via {@link toUserProvider}.
 */
export type UserProvider = 'database' | 'google';

/**
 * Normalize a raw registry provider value. Only the two recognized providers
 * pass through — empty, missing, or unrecognized values (a new provider the
 * backend adds before this client knows about it) become `undefined`, which
 * callers must treat as "unknown, preserve existing behavior", never as a
 * guessed provider.
 *
 * @param value - Raw `UserRegistryGetUserResponse.provider` string.
 * @returns The recognized provider, or undefined when unknown.
 */
export const toUserProvider = (value: unknown): UserProvider | undefined =>
  value === 'database' || value === 'google' ? value : undefined;
